import styled from 'styled-components';

export const ContainerButton = styled.div`
  height: 40px;
  padding-right: 10px;
  position: ${(props) => (props.position ? props.position : '')};
  right: ${(props) => (props.right ? 0 : '')};
`;
